import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import {
  CreditAlertOptions,
  CreditAlertStatus,
  EditCreditAlertDialogData, EditCreditAlertDialogResult, GetCreditAlertByStatusFn,
} from '@portal-workspace/grow-shared-library';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Subscription } from 'rxjs';

@Component({
    templateUrl: './edit-credit-alert.dialog.html',
    styleUrls: ['./edit-credit-alert.dialog.scss'],
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, FlexModule, MatButtonModule, MatDialogModule, MatSelectModule]
})
export class EditCreditAlertDialog implements OnInit{
  formControlName!: FormControl<string | null>;
  formControlDescription!: FormControl<string | null>;
  formControlStatus!: FormControl<CreditAlertStatus | null>;
  formControlCode!: FormControl<string | null>;
  formControlCondition!: FormControl<string | null>;
  formControlConditionDescription!: FormControl<string | null>;
  formGroup!: FormGroup;
  subscriptions: Subscription[] = [];
  isValidateSelected : boolean = false;
  conditionPattern = /^[_a-zA-Z][_a-zA-Z0-9\s]{0,255}$/;

  creditAlertOptions = CreditAlertOptions;
  getCreditAlertByStatusFn!: GetCreditAlertByStatusFn;

  constructor(@Inject(MAT_DIALOG_DATA) public data: EditCreditAlertDialogData,
              private dialogRef: MatDialogRef<EditCreditAlertDialog, EditCreditAlertDialogResult>,
              private formBuilder: FormBuilder) {
    const name = this.data.name ?? '';
    const description = this.data.description ?? '';
    const status = this.data.status ?? null;
    const code = this.data.code ?? '';
    const condition = this.data.condition ?? null;
    const conditionDescription = this.data.conditionDescription?? null;
    this.getCreditAlertByStatusFn = this.data.getCreditAlertByStatusFn
    this.formControlName = this.formBuilder.control(name, [Validators.required]);
    this.formControlDescription = this.formBuilder.control(description, [Validators.required]);
    this.formControlStatus = this.formBuilder.control(status, [Validators.required]);
    this.formControlCode = this.formBuilder.control(code, [Validators.required]);
    this.formControlCondition = this.formBuilder.control(condition);
    this.formControlConditionDescription = this.formBuilder.control(conditionDescription);
    this.formGroup = this.formBuilder.group({
      name: this.formControlName,
      description: this.formControlDescription,
      status: this.formControlStatus,
      code: this.formControlCode,
      condition: this.formControlCondition,
      conditionDescription: this.formControlConditionDescription,
    })
  }

  ngOnInit(): void {

    this.subscriptions.push(
      this.formControlStatus.valueChanges.subscribe((status) => {
        if (!status) return;
      this.formControlCode.updateValueAndValidity({ emitEvent: false });
        this.subscriptions.push(
          this.getCreditAlertByStatusFn(status).subscribe((statusCount: number) => {
            const updatedStatusCount = statusCount + 1;
            const codePrefix = status === 'Decline' ? 'CRDL' :
                              status === 'Refer' ? 'CRRF' :
                              status === 'Validate' ? 'CRVD' : 
                              status === 'Conditional' ? 'CRCD' : 'CR';
            this.formControlCode.setValue(`${codePrefix}${updatedStatusCount}`);
          })
        );
        this.isValidateSelected = status === 'Validate';
        if (!this.isValidateSelected) {
          this.formControlCondition.setValue(null);
          this.formControlConditionDescription.setValue(null);
          this.formControlCondition.clearValidators();
          this.formControlConditionDescription.clearValidators();
        } else {
          this.formControlCondition.clearValidators();
          this.formControlConditionDescription.clearValidators();
          this.formControlCondition.setValidators([Validators.required, Validators.pattern(this.conditionPattern)]);
          this.formControlConditionDescription.setValidators([Validators.required]);
        }

        this.formControlCondition.updateValueAndValidity();
        this.formControlConditionDescription.updateValueAndValidity();
      })
    );
    this.isValidateSelected = this.formControlStatus.value === 'Validate';
    if (!this.isValidateSelected) {
      this.formControlCondition.setValue(null);
      this.formControlConditionDescription.setValue(null);
    }
  }

  onSubmit(confirmation: boolean) {
    this.dialogRef.close({
      readyForSubmission: confirmation,
      name: this.formControlName.value ?? '',
      description: this.formControlDescription.value ?? '',
      status: this.formControlStatus.value as CreditAlertStatus,
      code: this.formControlCode.value ?? '',
      condition: this.formControlCondition.value ?? '',
      conditionDescription: this.formControlConditionDescription.value ?? ''
    })
  }
}
